<template>
    <div>
        <div class="card-title">
            {{type === 'add' ? $t('message.newPlan') : $t('message.updatePlan')}}
        </div>
        <vs-row>
            <vs-col>
                <vs-select v-model="plan.planTemplate" autocomplete :placeholder="$t('message.chooseTemplate')" style="width: 100%">
                    <vs-select-item :key="item._id" :value="item._id" :text="lang === 'en' ? item.name_en : item.name_zh" v-for="item in planTemplateOpt" />
                </vs-select>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <vs-input v-model="plan.name"  :placeholder="$t('message.subscriptedPlanEN')" style="width: 100%"></vs-input>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.name_zh"  :placeholder="$t('message.subscriptedPlanZH')" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <vs-select v-model="plan.currency" autocomplete :placeholder="$t('message.currency')" style="width: 100%">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in currencyOpt" />
                </vs-select>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.amount" type="number" @blur="getDividendPreview()" :placeholder="plan.amount === 0 ? '' : $t('message.balanceAmount')" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <datepicker class="fixedPicker" v-model="plan.effectiveDate" :placeholder="$t('message.validDate')" :format="format"
                            :highlighted="highlight"></datepicker>
            </vs-col>
            <vs-col vs-w="6">
                <datepicker class="fixedPicker" v-model="plan.expiryDate" :placeholder="$t('message.expiryDate')" :format="format"
                            :highlighted="highlight"></datepicker>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <vs-input v-model="plan.expectedAnnualReturn" :placeholder="$t('message.expectedAnnualReturn')" style="width: 100%"></vs-input>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.actualAnnualReturn" :placeholder="$t('message.actualAnnualReturn')" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="12">
                <vs-select v-model="plan.dividendMode" autocomplete :placeholder="$t('message.dividendMode')" style="width: 100%">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in dividendOpt" />
                </vs-select>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="12">
                <vx-chips type="beneficiary" :placeholder="$t('message.beneficiary')" v-model="plan.beneficiaries" :items.sync="plan.beneficiaries" @remove="onRemove"></vx-chips>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" >
            <vs-col vs-w="12">
                <vx-chips type="beneficiaryAfterDeath" :placeholder="$t('message.beneficiaryDeath')" v-model="plan.beneficiariesAfterDeath" :items.sync="plan.beneficiariesAfterDeath" @remove="onRemove"></vx-chips>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="12">
                <div class="list-title">{{$t('message.details')}}</div>
            </vs-col>
            <vs-col vs-w="6" class="m-t-1">
                <span class="detail-title">{{$t('message.totalConFromEffectiveDate')}} :</span>
            </vs-col>
            <vs-col vs-w="6" class="m-t-1">
                <vs-input v-model="plan.totalNetContributionSinceEffectiveDate" type="number" :placeholder="plan.totalNetContributionSinceEffectiveDate === 0 ? '' : $t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span class="detail-subtitle">- {{$t('message.totalConTransInAssets')}} :</span>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.totalTransferAsset" type="number" :placeholder="plan.totalTransferAsset === 0 ? '' : $t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span class="detail-subtitle">- {{$t('message.totalWithTransOutAssets')}}</span>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.totalTransferOutAsset" type="number" :placeholder="plan.totalTransferOutAsset === 0 ? '' : $t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span class="detail-title">{{$t('message.profitorLossFromEffectiveDate')}} :</span>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.investmentBalanceSinceEffectiveDate" type="number" :placeholder="plan.investmentBalanceSinceEffectiveDate === 0 ? '' :$t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span class="detail-subtitle">- {{$t('message.accountBalance')}} :</span>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.balance" type="number" :placeholder="plan.balance === 0 ? '' : $t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1" vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span class="detail-subtitle">- {{$t('message.accountReturns')}} :</span>
            </vs-col>
            <vs-col vs-w="6">
                <vs-input v-model="plan.return" type="number" :placeholder="plan.return === 0 ? '' :$t(`message.${plan.currency}`)" style="width: 100%"></vs-input>
            </vs-col>
        </vs-row>

        <vs-row v-if="showPreView">
            <vs-col>
                <div class="list-title">{{$t('message.dividend')}}</div>
                <vs-table :data="dividends" stripe class="preview-table" v-if="dividends.length > 0">
                    <template slot="thead">
                        <vs-th>
                            {{$t('message.periods')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.dividendDate')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.interest1')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.manageFee1')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.grossInterest')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.accumulated')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.rolloverAmount')}}
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="tr._id" v-for="(tr,indextr) in dividends">
                            <vs-td>
                                {{indextr + 1}}
                            </vs-td>
                            <vs-td :data="tr.datePayable">
                                {{tr.datePayable | dateFormat}}
                            </vs-td>
                            <vs-td :data="tr.interest">
                                {{tr.interest | priceFormat}}
                            </vs-td>
                            <vs-td :data="tr.managementFee">
                                {{tr.managementFee | priceFormat}}
                            </vs-td>
                            <vs-td :data="tr.grossInterest">
                                {{tr.grossInterest | priceFormat}}
                            </vs-td>
                            <vs-td :data="tr.accumulated">
                                {{tr.accumulated | priceFormat}}
                            </vs-td>
                            <vs-td :data="tr.rolloverAmount">
                                {{tr.rolloverAmount | priceFormat}}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-col>
        </vs-row>

        <vs-row style="margin-top: 20px">
            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                <span style="font-size: 18px;margin-right: 15px;color: #626262;">{{$t('message.quarterFundOverview')}}</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                <vs-button size="small" color="rgb(37, 105, 193)" type="border" style="border-radius: 15px;margin-right: 5px;" @click="$refs.file.click()">+ {{$t('message.selectFile')}}</vs-button>
                <input @change="onUpload($event)" id="file" ref="file"  type="file"  name="file" style="display: none;"/>
                <vs-icon icon="check_circle_outline" color="success" size="20px" v-if="plan.quarterlyFundOverview"></vs-icon>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-3">
            <vs-col v-if="type === 'add'" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="onAdd()" :disabled="uploading">{{$t('message.add')}}</vs-button>
            </vs-col>
            <vs-col v-else-if="type === 'update'" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdate()" :disabled="uploading">{{$t('message.update')}}</vs-button>
                <vs-button size="small" color="danger" class="stribtn" @click="onDelete()">{{$t('message.delete')}}</vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vxChips from "@/components/vx-chips/vxChips";
import moment from "moment";
export default {
    props: ["type", "data", "uploading"],
    data(){
        return{
            lang: '',
            token: '',
            format: 'dd / MM / yyyy',
            highlight: {
                customPredictor(date) {
                    if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                        return true;
                }
            },
            currencyOpt:[
                {value:'HKD',text:this.$t('message.HKD')},
                {value:'USD',text:this.$t('message.USD')},
                {value:'EUR',text:this.$t('message.EUR')},
                {value:'RMB',text:this.$t('message.RMB')},
            ],
            dividendOpt: [
                {value: 'Simple', text: this.$t('message.simple')},
                {value: 'Compound', text: this.$t('message.compound')},
                {value: 'Half Yearly', text: this.$t('message.halfYearly')}
            ],
            plan: this.data,
            planTemplateOpt: [],
            length: '',
            showPreView: false,
            dividends: [],
            interestRate: '',
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
        this.token = this.$cookies.get('token');
        let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate/pair?access_token=' + this.$cookies.get('token');
        fetch(url).then((res) => {
            return res.json()
        }).then((data) => {
            this.planTemplateOpt = data.responseDetail.data;
        })
    },
    watch:{
        "data"(newVal){
            this.plan = newVal;
            this.showPreView = false;
            this.dividends = [];
        },
        length(newVal){
            if(this.plan.effectiveDate){
                this.plan.expiryDate = moment(this.plan.effectiveDate).add(newVal, 'months').format();
            }
        },
        "plan.effectiveDate"(newVal){
            if(newVal && this.length){
                this.plan.expiryDate = moment(newVal).add(this.length, 'months').format();
            }
            this.getDividendPreview();
        },
        "plan.planTemplate"(newVal){
            let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate/' + newVal + '?access_token=' + this.token;
            fetch(url).then((res) => {
                return res.json()
            }).then((data) => {
                this.plan.name = data.responseDetail.name_en || '';
                this.plan.name_zh = data.responseDetail.name_zh || '';
                this.plan.currency = data.responseDetail.currency || 'HKD';
                this.interestRate = data.responseDetail.interestRate;
                this.length = data.responseDetail.length;
                this.getDividendPreview();
            })
        },
        "plan.dividendMode"(){
            this.getDividendPreview();
        },
        "plan.amount"(newVal){
            this.plan.expectedAnnualReturn = newVal * this.interestRate / 100;
        }
    },
    methods: {
        getDividendPreview(){
            let query = this.$qs.stringify({
                access_token: this.token,
                planTemplate: this.plan.planTemplate,
                amount: this.plan.amount,
                effectiveDate: this.plan.effectiveDate,
                dividendMode: this.plan.dividendMode,
            })

            if(this.plan.planTemplate && this.plan.amount && this.plan.effectiveDate && this.plan.dividendMode){
                console.log(query)
                let url = process.env.VUE_APP_API_BASEURL + '/api/plan/dividend?' + query;
                fetch(url).then((res) => {
                    return res.json()
                }).then((data) => {
                    console.log(data);
                    this.showPreView = true;
                    this.dividends = data.responseDetail;
                })
            }
        },
        onUpload(e){
            this.$emit("upload",e)
        },
        onAdd(){
            if(this.plan.beneficiariesAfterDeath.length === 0 || this.plan.beneficiaries.length === 0){
                return this.$vs.notify({
                    title:'提示',
                    text: '請填入生前/身故受益人',
                    icon: 'clear',
                    color:'danger',
                    position:'top-center',
                    time: 3000
                });
            }
            this.$emit("update:data", this.plan);
            this.$emit("add");
        },
        onUpdate(){
            this.$emit("update");

        },
        onDelete(){
            this.$emit("delete");
        },
        onRemove(type,item){
            switch (type){
                case 'beneficiary':{
                    this.plan.beneficiaries.splice(item,1);
                    break;
                }
                case 'beneficiaryAfterDeath':{
                    this.plan.beneficiariesAfterDeath.splice(item,1);
                    break;
                }
            }
        },
    },
    components: {
        Datepicker,
        vxChips,
    },
}
</script>

<style>
    .list-title{
        margin-top: 20px;
        font-size: 18px;
        margin-right: 15px;
        color: #626262;
    }
    .preview-table.vs-con-table{
        margin-top: 10px;
        overflow: scroll;
    }
    .preview-table.vs-con-table .th{
        white-space: nowrap;
    }
    .preview-table.vs-con-table .td{
        white-space: nowrap;
    }
</style>
